export type ScheduleType = 'weekly' | 'monthly';

export type OccurrenceType = 'first' | 'second' | 'third' | 'fourth' | 'last';

export type WeekDay =
    | 'monday'
    | 'tuesday'
    | 'wednesday'
    | 'thursday'
    | 'friday'
    | 'saturday'
    | 'sunday';

export interface InventoryReminderScheduleConfig {
    type: ScheduleType;
    daysOfMonth?: number[];
    daysOfWeek?: WeekDay[];
    occurrence?: OccurrenceType;
    dayOfWeek?: WeekDay;
}

export const WEEKDAYS: { value: WeekDay; labelKey: string }[] = [
    { value: 'monday', labelKey: 'settings.inventoryReminder.weekday.monday' },
    {
        value: 'tuesday',
        labelKey: 'settings.inventoryReminder.weekday.tuesday',
    },
    {
        value: 'wednesday',
        labelKey: 'settings.inventoryReminder.weekday.wednesday',
    },
    {
        value: 'thursday',
        labelKey: 'settings.inventoryReminder.weekday.thursday',
    },
    { value: 'friday', labelKey: 'settings.inventoryReminder.weekday.friday' },
    {
        value: 'saturday',
        labelKey: 'settings.inventoryReminder.weekday.saturday',
    },
    { value: 'sunday', labelKey: 'settings.inventoryReminder.weekday.sunday' },
];

export const OCCURRENCES: { value: OccurrenceType; labelKey: string }[] = [
    { value: 'first', labelKey: 'settings.inventoryReminder.occurrence.first' },
    {
        value: 'second',
        labelKey: 'settings.inventoryReminder.occurrence.second',
    },
    { value: 'third', labelKey: 'settings.inventoryReminder.occurrence.third' },
    {
        value: 'fourth',
        labelKey: 'settings.inventoryReminder.occurrence.fourth',
    },
    { value: 'last', labelKey: 'settings.inventoryReminder.occurrence.last' },
];
